export const adaptFase = (faseData) => {
    return {
        id: faseData?.idFase,
        displayName: faseData?.nombre,
        name: faseData?.nombre
    }
}

export const adaptFaseArray = (
    fases
) => {
    return structuredClone(fases?.allFase)
        ?.map(fase => adaptFase(fase));
}